<div fxLayout="row" class="containerMenu noPrint">
    <div fxLayout="row" fxLayoutGap="1.5rem" fxLayoutAlign="space-between center"
        fxLayoutAlign.lt-lg="space-between center" fxFlex="100%" fxShow="true" fxShow.lt-md="false">

        <!-- seccion izquierda LOGO  -->
        <div routerLink="/" fxLayout="row" fxLayoutAlign=" center" class="mgl20 cursorPointer">
            <img [src]="logo" alt="logoPredictiva21" class="logoMenu">
            <span class="mgl10 ft500 navLink gray-9" fxShow="true" fxShow.lt-md="false">Predyc</span> 
            <span class="mgl05 navLink gray-5" fxShow="true" fxShow.lt-md="false">BETA</span> 
        </div>


        <!-- seccion central -->
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1.5rem">

            <a *ngIf="token == 'instructor'" routerLink="/inst/resumen/{{user.instructorId}}" fxShow.lt-lg="false" fxShow="true"
                class="gray-8 ft16 ft500 mgr10">
                Dashboard Instructor
            </a>

            <a *ngIf="token != 'instructor'" routerLink="/buscar" fxShow.lt-lg="false" fxShow="true"
                class="navLink ft500 nowrap">
                Explorar cursos
            </a>

            <div *ngIf="token != 'instructor'" fxLayout="row" fxLayoutAlign="center center" fxFlex.lt-lg="100%"
                fxShow.lt-md="false">
                <input type="text" [(ngModel)]="textoBusqueda" placeholder="Buscar un curso" ngClass.lt-lg="w-100"
                    (keyup.enter)="buscarTexto()" class="buscador">
            </div>

            <a *ngIf="token != 'instructor'" routerLink="/ensena" class="navLink ft500 nowrap" fxShow.lt-lg="false"
                fxShow="true">
                Enseña en Predyc
            </a>

            <a *ngIf="token != 'instructor'" routerLink="/capacitacion-empresas" class="navLink ft500 nowrap"
                fxShow.lt-lg="false" fxShow="true">
                Cursos para empresas
            </a>

            <a *ngIf="token == 'estudiante' || token == 'superadmin'" href="" routerLink="est/mis-cursos"
                routerLinkActive="active" class="navLink ft500 nowrap" fxShow.lt-md="false" fxShow="true">
                Mis cursos
            </a>
        </div>

        <!-- seccion derecha inicio sesion y registro visible unicamente para visitantes -->
        <div *ngIf="token == null" fxShow.lt-md="false" fxShow="true">
            <button (click)="openLogIn()" class="grayLink grayButton ft500 mgr10 nowrap">
                Iniciar sesión
            </button>

            <button (click)="openSignUp()" class="darkButton ft500 mgr20 nowrap">
                Regístrate
            </button>
        </div>

        <!-- seccion derecha usuario visible unicamente para logged in-->
        <div *ngIf="token != null" mat-icon-button [matMenuTriggerFor]="menu" fxShow.lt-md="false" fxShow="true"
            class="cursorPointer fh mgr20" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2rem">

            <!-- foto perfil -->
            <span *ngIf="token != 'instructor'" class="navLink ft500">{{primerNombre}}</span>
            <span *ngIf="token == 'instructor'" class="navLink ft500">{{user.nombre}}</span>

            <!-- nombre -->
            <img *ngIf="user.photoURL" [src]="user.photoURL" alt="foto de perfil" class="avatar2">
            <img *ngIf="user.photoURL == null" [src]="defaultUserImage" alt="foto de perfil" class="avatar2">

        </div>

    </div>

    <!-- menu desplegable del usuario al hacer click -->
    <mat-menu #menu="matMenu" class="radius3 fw w250px" fxShow.lt-md="false" fxShow="true">
        <div *ngIf="token != null" fxLayout="column" class="pd10 w250px" ngClass.lt-md="vw100">

            <!-- foto perfil -->
            <img *ngIf="token != 'instructor'" [src]="user.photoURL" alt="foto de perfil" fxLayout="row"
                fxLayoutAlign="center" class="imgUsuarioGrande">
            <img *ngIf="token == 'instructor'" [src]="defaultUserImage" alt="foto de perfil" fxLayout="row"
                fxLayoutAlign="center" class="imgUsuarioGrande">

            <!-- nombre -->
            <p *ngIf="token != 'instructor'" class="ft12 ft500 centertext" fxLayout="row" fxLayoutAlign="center">
                {{user.nombreCompleto}}
            </p>
            <p *ngIf="token == 'instructor'" class="ft12 ft500 centertext" fxLayout="row" fxLayoutAlign="center">
                {{user.nombre}}
            </p>

            <!-- link mi cuenta -->
            <a *ngIf="token != 'instructor'" routerLink="/est/mi-cuenta" class="ft11 grayLink mgb05">Mi cuenta</a>

            <!-- link dashboard admin -->
            <a *ngIf="token == 'superadmin' || token == 'administrador' || token == 'editor'"
                class="ft11 grayLink mgb05" routerLink="/admin/resumen">
                Dashboard admin
            </a>

            <!-- dashboard instructor -->
            <a *ngIf="token == 'instructor'" routerLink="/inst/resumen/{{user.instructorId}}"  class="ft11 grayLink mgb05">
                Dashboard instructor
            </a>

            <!-- informativas -->
            <a routerLink="/soporte" class="ft11 grayLink mgb05"> Soporte </a>
            <a routerLink="/faq" class="ft11 grayLink mgb05"> FAQ </a>
            <a routerLink="/politica-privacidad" class="ft11 grayLink mgb05"> Política de privacidad </a>
            <a routerLink="/terminos-condiciones" class="ft11 grayLink mgb05"> Condiciones de uso </a>
            <a routerLink="/politica-cookies" class="ft11 grayLink mgb05"> Política de cookies </a>
            <!-- cerrar sesion -->
            <a href="" class="ft11 grayLink" (click)="signOut()">Cerrar sesión</a>
        </div>
    </mat-menu>


    <!-- Menu mobile selector aparece cuando la media es menor a MD-->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="2rem" fxShow="false" fxShow.lt-md="true"
        fxFlex="100%">
        <img [src]="logo" alt="logoPredictiva21" class="logoMenu mgl10" routerLink="/">
        <span routerLink="/" class="ft18 ft500 navLink">Predyc
        <span class="ft400 gray-5">BETA</span>
        </span>
        <mat-icon (click)="menuOpen=1" *ngIf="menuOpen===0" class="gray-8 mgr10">menu</mat-icon>
        <mat-icon (click)="menuOpen=0" *ngIf="menuOpen===1" class="gray-8 mgr10">close</mat-icon>
    </div>


    <!-- Menu mobile visible al hacer click en el toggle -->
    <div class="menuMobile" [ngClass]=" {'menuMobile-visible':menuOpen === 1}" fxShow="false" fxShow.lt-md="true">
        <div fxLayout="column" class="pd10 border-t">

            <img [src]="user.photoURL" alt="foto de perfil" class="imgUsuarioGrande" fxLayout="row"
                fxLayoutAlign="center" *ngIf="token != null">
            <p class="ft16 ft500 centertext mgb05" fxLayout="row" fxLayoutAlign="center"
                *ngIf="token != null && token != 'instructor'">
                {{user.nombreCompleto}}</p>

            <span href="" class="ft16 grayLink pd10 centertext" *ngIf="token == null" (click)="openLogIn()">Iniciar
                sesion</span>
            <span href="" class="ft16 grayLink pd10 border-t centertext" *ngIf="token === null"
                (click)="openSignUp()">Registrarte</span>
            <a routerLink="/buscar" class="ft16 grayLink pd10 border-t centertext" (click)="menuOpen=0"> Explorar cursos </a>
            <a *ngIf="token != null && token != 'instructor'" routerLink="est/mis-cursos"
                class="ft16 grayLink pd10 border-t centertext" (click)="menuOpen=0"> Mis cursos </a>
            <a *ngIf="token != null && token != 'instructor'" href="" routerLink="est/mi-cuenta"
                class="ft16 grayLink pd10 border-t centertext" (click)="menuOpen=0">Mi
                cuenta</a>
            <a *ngIf="token != 'instructor'" routerLink="/ensena" class="ft16 grayLink pd10 border-t centertext" (click)="menuOpen=0"> Enseña
                en Predyc </a>
            <a *ngIf="token != 'instructor'" routerLink="/capacitacion-empresas"
                class="ft16 grayLink pd10 border-t centertext" (click)="menuOpen=0"> Capacitación para empresas </a>

            <a routerLink="/soporte" class="ft16 grayLink pd10 border-t centertext" (click)="menuOpen=0"> Soporte </a>
            <a routerLink="/politica-privacidad" class="ft16 grayLink pd10 border-t centertext" (click)="menuOpen=0"> Política de privacidad
            </a>
            <a routerLink="/faq" class="ft16 grayLink pd10 border-t centertext" (click)="menuOpen=0"> FAQ
            </a>
            <a routerLink="/politica-cookies" class="ft16 grayLink pd10 border-t centertext" (click)="menuOpen=0"> Política de cookies
            </a>

            <a *ngIf="token != null" href="" class="ft16 grayLink pd10 border-t centertext" (click)="signOut()">Cerrar
                sesión</a>
        </div>
    </div>
</div>